/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API48252Item {
  
  /** Object */
  code?: any;
  
  /**  */
  desc?: string;
  
};
    
  



  export type API48252Req = {};



export interface API48252Res {
  /** T  */
  list?: API48252Item[];
  
};


// 48252 业务域枚举列表

export interface IUseGetAPI48252Return {
  /** 业务域枚举列表: 接口请求状态 */
  isAPI48252Loading: boolean;
  /** 业务域枚举列表: 接口请求返回数据 */
  dataAPI48252: API48252Res;
  /**  业务域枚举列表: 接口数据请求方法 */
  fetchAPI48252Data:  ( config?: YWRequestConfig) => Promise<API48252Res>;
  /** 业务域枚举列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48252 = ():IUseGetAPI48252Return => {
  let isMount = true;
  const [isAPI48252Loading, setIsAPI48252Loading] = useState(false);
  const [dataAPI48252, setDataAPI48252] = useState<API48252Res>({} as API48252Res);
  const requestUrl = `${basePath}/team-work/workTask/listBizDomainEnum`;

  const fetchAPI48252Data = async ( config?: YWRequestConfig): Promise<API48252Res> => {
  
    if ( isMount ) {
      setIsAPI48252Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48252Res>(`${basePath}/team-work/workTask/listBizDomainEnum`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48252(res || {} as API48252Res);
        setIsAPI48252Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48252Loading(false);
      }
      return false as unknown as API48252Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48252Loading,
    dataAPI48252,
    fetchAPI48252Data,
    requestUrl,
  }
}

